import useWalkthroughQuery from './useWalkthroughQuery'

const useWalkthrough = (uuid: string, usePublicEndpoint?: boolean) => {
  const contentProps = useWalkthroughQuery(uuid, usePublicEndpoint)
  return { content: { ...contentProps } }
}

export default useWalkthrough
